<template>
  <div class="user-menu" @click.stop="$emit('toggle')">
    <div class="user-name">{{ userName }}</div>
    <img class="avatar-dot img" :src="avatar" alt="avatar" />

    <div v-if="open" class="menu-dropdown">
      <button class="menu-item" @click.stop="$emit('go-account')">
        账号管理
      </button>

      <div class="menu-divider"></div>
      <button class="menu-item logout-btn" @click.stop="$emit('logout')">
        退出登录
      </button>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  userName: {
    type: String,
    default: "默认昵称",
  },
  avatar: {
    type: String,
    default: "",
  },
});

defineEmits(["toggle", "go-account", "logout"]);
</script>

<style scoped>
.menu-divider {
  height: 1px;
  background-color: #f0f0f0;
  margin: 4px 0;
}

.logout-btn {
  color: #ef4444;
}

.logout-btn:hover {
  background-color: #fef2f2;
}
</style>
